/** First-time user onboarding journeys (per user, stored in localStorage). */

export const JOURNEY_IDS = {
  DASHBOARD: 'dashboard',
  VIDEO_EDITOR: 'video_editor',
};

const STATUS_COMPLETED = 'completed';
const STATUS_SKIPPED = 'skipped';

function statusKey(userId, journeyId) {
  return `twinnee_onboarding_${userId}_${journeyId}`;
}

function pendingKey(userId) {
  return `twinnee_onboarding_${userId}_pending`;
}

export function getStoredUser() {
  try {
    return JSON.parse(localStorage.getItem('storycraft_user') || '{}');
  } catch {
    return {};
  }
}

export function getJourneyStatus(userId, journeyId) {
  if (!userId) return null;
  return localStorage.getItem(statusKey(userId, journeyId));
}

export function isJourneyDone(userId, journeyId) {
  const st = getJourneyStatus(userId, journeyId);
  return st === STATUS_COMPLETED || st === STATUS_SKIPPED;
}

/** Call after successful registration. */
export function queueOnboardingAfterSignup(userId) {
  if (!userId) return;
  localStorage.setItem(pendingKey(userId), JOURNEY_IDS.DASHBOARD);
  localStorage.setItem(`twinnee_onboarding_${userId}_signup_at`, String(Date.now()));
}

export function shouldStartJourney(userId, journeyId) {
  if (!userId || isJourneyDone(userId, journeyId)) return false;
  return localStorage.getItem(pendingKey(userId)) === journeyId;
}

export function completeJourney(userId, journeyId) {
  if (!userId) return;
  localStorage.setItem(statusKey(userId, journeyId), STATUS_COMPLETED);
  if (journeyId === JOURNEY_IDS.DASHBOARD) {
    localStorage.setItem(pendingKey(userId), JOURNEY_IDS.VIDEO_EDITOR);
  } else if (journeyId === JOURNEY_IDS.VIDEO_EDITOR) {
    localStorage.removeItem(pendingKey(userId));
  }
}

export function skipJourney(userId, journeyId) {
  if (!userId) return;
  localStorage.setItem(statusKey(userId, journeyId), STATUS_SKIPPED);
  if (journeyId === JOURNEY_IDS.DASHBOARD) {
    localStorage.setItem(pendingKey(userId), JOURNEY_IDS.VIDEO_EDITOR);
  } else {
    localStorage.removeItem(pendingKey(userId));
  }
}
